import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client/core';

export const GET_SUBMISSION_TASK_ENTITY = gql`
  query taskLabels {
    taskLabels {
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          name
        }
      }
    }
  }
`;

export function useSubmissionTaskType({
  enabled = true,
}: {
  enabled?: boolean;
}) {
  const { loading, error, data } = useQuery(GET_SUBMISSION_TASK_ENTITY, {
    skip: !enabled,
  });
  return {
    error,
    loading,
    data,
  };
}
